module.exports = __webpack_public_path__ + "img/nav-sentosa.7c542038.svg";